/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ILocationType {
  Forest = 'Forest',
  Beach = 'Beach',
  Mountains = 'Mountains',
  Desert = 'Desert',
  City = 'City',
  Savannahs = 'Savannahs',
  Landmarks = 'Landmarks',
  Studio = 'Studio',
  Waterfront = 'Waterfront',
}
